<template>
	<div class="events">
    <v-app id="events">
      <v-content>
        <v-layout align-center justify-center>
          <v-card-title><b>{{ $route.params.slug | uppercase }} {{ $t('category_events') }}</b></v-card-title>
        </v-layout>
        <div class="container is-fluid">
          <div class="columns is-multiline">
            <div class="hidden-sm-and-down">
              <div class="column is-12">
                <div class="label title is-3">{{ $t('category_events') }} :</div>
                <v-text-field v-model="search" append-icon="mdi-magnify" :label="'Search ' + '(' + filteredEvents.length + ') '+ $route.params.slug" single-line hide-details>
                  
                </v-text-field>
                <v-menu bottom offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn class="mt-2 mb-2" v-on="on" rounded medium color="indigo lighten-1" style="width: 80%;" dark outlined>
                      {{ $t('category_subcategory') }}
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item v-for="sub in subpro" :key="sub.id">
                      <router-link :to="'/subcategories/'+ sub.slug">
                        <v-list-item-title>
                          <b>{{sub.name | capitalize}}</b>
                        </v-list-item-title>
                      </router-link>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <select v-model="townFilter" class="select-css" style="border-radius: 25px; width: 80%">
                  <option value="All" selected>
                    <b v-if="townFilter !== 'All'">{{ $t('category_all') }}</b>
                    <b v-if="townFilter === 'All'">{{ $t('category_province') }}</b>
                  </option>
                  <option value="lusaka">Lusaka</option>
                  <option value="Lusaka District">Central</option>
                  <option value="central">Copperbelt</option>
                  <option value="central">Southern</option>
                  <option value="central">Eastern</option>
                  <option value="central">Western</option>
                  <option value="central">North-Western</option>
                  <option value="central">Luapula</option>
                  <option value="central">Northern</option>
                  <option value="central">Muchinga</option>
                </select>
                <p style="margin-bottom: 7px;"></p>
                <select v-model="monthFilter" class="select-css" style="border-radius: 25px; width: 80%">
                  <option value="All" selected>
                    <b v-if="monthFilter !== 'All'">{{ $t('category_all') }}</b>
                    <b v-if="monthFilter === 'All'">{{ $t('category_month') }}</b>
                  </option>
                  <option value="january">{{ $t('category_month_january') }}</option>
                  <option value="february">{{ $t('category_month_february') }}</option>
                  <option value="march">{{ $t('category_month_march') }}</option>
                  <option value="april">{{ $t('category_month_april') }}</option>
                  <option value="may">{{ $t('category_month_may') }}</option>
                  <option value="june">{{ $t('category_month_june') }}</option>
                  <option value="july">{{ $t('category_month_july') }}</option>
                  <option value="august">{{ $t('category_month_august') }}</option>
                  <option value="september">{{ $t('category_month_september') }}</option>
                  <option value="october">{{ $t('category_month_october') }}</option>
                  <option value="november">{{ $t('category_month_november') }}</option>
                  <option value="december">{{ $t('category_month_december') }}</option>
                </select>
                <p style="margin-bottom: 7px;"></p>
                <select v-model="typeFilter" class="select-css" style="border-radius: 25px; width: 80%">
                  <option value="All" selected>
                    <b v-if="typeFilter !== 'All'">{{ $t('category_all') }}</b>
                    <b v-if="typeFilter === 'All'">{{ $t('category_type') }}</b>
                  </option>
                  <option value="new">{{ $t('category_type_new') }}</option>
                  <option value="discount">{{ $t('category_type_discount') }}</option>
                  <option value="">{{ $t('category_type_rated') }}</option>
                  <option value="">{{ $t('category_type_reviewed') }}</option>
                  <option value="giveaway">{{ $t('category_type_sale') }}</option>
                </select>
                <span v-if="typeFilter != 'giveaway'"><v-checkbox v-model="typeFilter" label="Show Only Free Events" color="indigo darken-3" value="giveaway" input-value="true"></v-checkbox></span>
                <span v-if="typeFilter == 'giveaway'"><v-checkbox v-model="typeFilter" label="Show Only Popular Items" color="grey darken-3" value="All" input-value="false"></v-checkbox></span>
              </div>
            </div>
            <div class="hidden-md-and-up">
              <div class="column is-12">
                <div class="columns">
                  <div  class="column is-6">
                     <v-text-field v-model="search" append-icon="mdi-magnify" label="Search Products" single-line hide-details></v-text-field>
                  </div> 
                </div>
              </div>
              <v-divider></v-divider>
            </div>
            <div class="column is-3" v-for="event in filteredEvents" :key="event.id">
              <event :event="event" style="pointer-events: auto;"/>
            </div>
          </div>
        </div>
        <generalfab />
      </v-content>
    </v-app>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex'
  import {fb,db} from '@/firebase'

  export default {
    name : "events",
    data: () => ({
      nav_title: 'Events Page',
      months: ['All','January','February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      province: ['All','Lusaka', 'Copperbelt', 'Central', 'Southern', 'Eastern', 'Western','North-Western', 'Luapula', 'Northern', 'Muchinga'],
      search: '',
    }),

    created(){
      this.uid =fb.auth().currentUser.uid
    },

    mounted() {
      this.initCategory(this.$route.params.slug)
    },

    computed: {
      ...mapState('mainCategoryModule', ['events']),
      ...mapGetters({
        category: 'mainCategoryModule/category'
      }),

      userIsAuthenticated () {
        return this.uid !== null && this.uid !== undefined
      },

      filteredEvents() {
        if (this.search) {
          const regexp = new RegExp(this.search, 'gi')
          return this.events.filter(event =>
            (event.name + event.client).match(regexp))
        }
        return this.events
      }
    },

    watch: {
      '$route.params.slug': () => {
        this.initCategory(this.$route.params.slug)
      },
      category() {
        if (this.category.id) {
          this.initEvente(this.category.id)
        }
      }
    },

    methods: {
      getImage(eventImages){
        return eventImages[0]
      },

      goToSignIn(){
        this.$router.push('/signin')
      },// sign?back

      addToEventCart(){
        db.collection('cartitems').add({
          event_name: this.event.name,
          event_image: this.event.eventImages,
          event_price: this.event.price,
          client_name: this.event.client,
          client_town: this.event.town_code,
          event_quantity: this.quantityValue,
          event_total: this.total,
          event_id: this.event.id,
          user: this.uid
        }).then(() => {
        /* eslint-disable */
        Toast.fire({
          type: 'success',
          title: 'event added to cart'
        })
        }).catch(err => {
            console.log(err);
        })
        /* eslint-enable */
      },

      ...mapActions('mainCategoryModule', 
        [ 
          'initCategory', 
          'initEvente'
        ]
      ),

      back(){
        this.$router.go(-1)
      }
    }
  }
</script>